import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { UpdateCompanyClientSinceSchema } from '../schemas/updateCompanyClientSince.schema'

type useUpdateCompanyClientSinceProps = {
  companyId?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useUpdateCompanyClientSince = ({ companyId, onSuccess, onError }: useUpdateCompanyClientSinceProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateCompanyClientSince', companyId],
    mutationFn: async (form: UpdateCompanyClientSinceSchema) => {
      const payload = {
        client_since: form.client_since
      }

      return privateAxios.put(`/client/companies/${companyId}`, { company: payload })
    },
    onSuccess,
    onError,
  })
}

